define("shared/types/instagram", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.InstagramMediaType = _exports.InstagramMediaProductType = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let InstagramMediaType = _exports.InstagramMediaType = /*#__PURE__*/function (InstagramMediaType) {
    InstagramMediaType["Image"] = "IMAGE";
    InstagramMediaType["Video"] = "VIDEO";
    InstagramMediaType["CarouselAlbum"] = "CAROUSEL_ALBUM";
    return InstagramMediaType;
  }({});
  let InstagramMediaProductType = _exports.InstagramMediaProductType = /*#__PURE__*/function (InstagramMediaProductType) {
    InstagramMediaProductType["Ad"] = "AD";
    InstagramMediaProductType["Feed"] = "FEED";
    InstagramMediaProductType["Story"] = "STORY";
    InstagramMediaProductType["Reels"] = "REELS";
    return InstagramMediaProductType;
  }({});
});